import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./GuestRegistrationForm.module.css";
import { useSearchParams } from "react-router-dom";
import { useApi } from "../../hooks/api";
import { ContentOrLoading } from "../../components/Loadings/ContentOrLoading";
import Button from "../../components/Buttons/Button";
import { secondary } from "../../theme";
import { useGlobal } from "../../hooks/global";

function formatCNPJ(cnpj: string): string {
    const cleaned = cnpj.replace(/\D/g, '');

    return cleaned.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
    );
}

function formatPhoneNumber(phone: string): string {
    const cleaned = phone.replace(/\D/g, '');

    return cleaned.length === 11
        ? cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
        : cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
}

const GuestPdf = () => {
    const [params] = useSearchParams();

    const { api } = useApi();
    const { theme } = useGlobal();

    const [data, setData] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const printRef: any = useRef();

    const handlePdfGuests = useCallback(async (id: string) => {
        setIsLoading(true)

        try {
            const dataPdf = await api.get(`/pdf/${id}`);

            setData(dataPdf.data);
        } catch (err) {
            console.error("ERRO: ", err)
        }

        setIsLoading(false)
    }, []);

    useEffect(() => {
        const id = params.get("reservation-id");

        if (!id) return;

        handlePdfGuests(id);

    }, [params.get("reservation-id")]);

    return (
        <div style={{ backgroundColor: '#eee', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column', fontFamily: 'Poppins, sans-serif' }}>
            <Button
                className={`no-print ${styles.btn}`}
                onClick={() => window.print()}
                style={{
                    whiteSpace: "nowrap",
                    fontSize: '14px',
                    maxWidth: 150,
                    marginTop: '90px',
                    marginBottom: '10px'
                }}
                background={secondary[theme]}
                borderColor={secondary[theme]}
                color="#FFF"
                children="Imprimir"
            />
            <ContentOrLoading loading={isLoading} theme="light">
                <div className={styles.container} ref={printRef} style={{ width: '800px' }}>
                    {data?.data?.guests?.map((item: any, index: any) => (
                        <table className={`table ${styles.table}`} style={{ marginBottom: `${data?.data?.guests.length === (index + 1) ? '' : '60px'}` }}>
                            <tbody>
                                <tr>
                                    <td colSpan={6} className={styles.bt0}>
                                        <div style={{ display: 'flex', flex: 1, flexDirection: 'row', marginBottom: '30px' }}>
                                            <div >
                                                <h1 className={styles.mt0}>
                                                    Ficha de registro de hóspedes<br />
                                                    <small style={{ fontSize: '17px', color: '#777', fontWeight: 500 }}>{item?.name}</small>
                                                </h1>
                                            </div>


                                            <div style={{ justifyContent: 'end', flex: 1, display: 'flex' }}>
                                                <img
                                                    style={{ maxHeight: 65 }}
                                                    src={data?.logo}
                                                    alt="Logo"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan={4}>
                                        <strong>Endereço da acomodação:</strong>
                                        <br />
                                        {data?.data.acomodacaoLocalizacao}
                                    </td>
                                    <td colSpan={2}>
                                        <strong>Código da acomodação:</strong>
                                        <br />
                                        {data?.data.acomodacaoCodigo}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <strong>Nome completo:</strong>
                                        <br />
                                        {item?.name}
                                    </td>
                                    <td colSpan={2}>
                                        <strong>Código de reserva:</strong>
                                        <br />
                                        {data?.data.reservaCodigo}
                                    </td>
                                    <td colSpan={1}>
                                        <strong>Telefone:</strong>
                                        <br />
                                        {item?.phone}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <strong>Nacionalidade:</strong>
                                        <br />
                                        BR
                                    </td>
                                    <td colSpan={2}>
                                        <strong>Check-in:</strong>
                                        <br />
                                        {data?.data.reservaDataEntrada}
                                    </td>
                                    <td colSpan={1}>
                                        <strong>Checkout:</strong>
                                        <br />
                                        {data?.data.reservaDataSaida}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <strong>Idade:</strong>
                                        <br />

                                    </td>
                                    <td colSpan={2}>
                                        <strong>Gênero:</strong>
                                        <br />

                                        F ( &nbsp; ) M ( &nbsp; )
                                    </td>
                                    <td colSpan={1}>
                                        <strong>Profissão:</strong>
                                        <br />

                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <strong>Documento:</strong>
                                        <br />
                                        {item?.document_type === 'cpf' ? '(CPF) ' : ''}
                                        {item?.document_type === 'rg' ? '(RG) ' : ''}
                                        {item?.document_type === 'passport' ? '(PASSAPORTE) ' : ''}
                                        {item?.document}
                                        <br />
                                    </td>
                                    <td colSpan={1}>
                                        <strong>Origem:</strong>
                                        <br />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <strong>Endereço:</strong>
                                        <br /><br />
                                    </td>
                                    <td colSpan={1}>
                                        <strong>Destino:</strong>
                                        <br />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <strong>Assinatura:</strong>
                                        <br />
                                    </td>
                                    <td colSpan={2}>
                                        <strong>Motivo de viagem:</strong>
                                        <br />
                                        Turismo ( &nbsp; )
                                        &nbsp; Evento ( &nbsp; )
                                        &nbsp; Negócio ( &nbsp; )
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ border: 'none', padding: '4px 0px !important' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                            <strong>DOCUMENTO (FRENTE):</strong>
                                            <img style={{ maxHeight: '400px', maxWidth: '430px', objectFit: 'contain' }} src={item?.document_image_front} />
                                        </div>
                                        <br />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={6} style={{ border: 'none' }}>
                                        <div style={{ display: 'flex', gap: 40, fontSize: '10px' }} className="mt-4">
                                            <div className="col-xs-4 text-left">
                                                <strong>{data.constantsCompany?.COMPANY_FANTASY_NAME}</strong>
                                                <br />
                                                CNPJ: {formatCNPJ(data.constantsCompany?.COMPANY_CNPJ)}
                                            </div>
                                            <div className="col-xs-6 text-left">
                                                <strong>Endereço</strong><br />
                                                {data.constantsCompany?.COMPANY_STREET},
                                                {data.constantsCompany?.COMPANY_NUMBER},
                                                {data.constantsCompany?.COMPANY_COMPLEMENT}
                                                <br />
                                                {data.constantsCompany?.COMPANY_CITY} {data.constantsCompany?.COMPANY_DISTRICT}
                                                <br />Cep {data.constantsCompany?.COMPANY_CEP}
                                            </div>
                                            <div className="col-xs-2 text-left">
                                                <strong>Contatos</strong><br />
                                                {formatPhoneNumber(data?.constantsCompany?.COMPANY_PHONE || '')}
                                                <br />
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    ))}

                </div>
            </ContentOrLoading>
        </div>
    );
};

export default GuestPdf;
